/**
 * Created by Zac on 22/05/2016.
 */


$(function () {
    // $('body').on('spaced-complete', function(){
    //     if (DEBUGGING) console.log('Spaced callback received');
    //     ///Only currently used on ttc-familyviolence
    //     $('.StartSpaced').text($('.StartSpaced').text($(this).data("text-after")));
    // })


        $('.SCORMcompleted').on('click', function () {
            if (DEBUGGING) console.log('SCORM callback received');
            ///Only currently used on ttc-familyviolence
            if ($(this).attr("data-text-after")) {
                $(this).html($(this).attr('data-text-after'));
                //Closes the SCORM popup
                if (window.opener && window.opener !== window) {
                    window.close();
                }
            }
        });

})


// WEBPACK FOOTER //
// Glasshouse/Core/js/spaced.js